// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const sackStack = defineModel({
  id: "sack-stack",
  batchId: "future",
  name: "Sack stack",
  tags: ["scenery","sack","stack","low-poly","age-of-mcp","future"],
  summary: "Piled sacks — grain, flour, salt and other loose goods.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.SphereGeometry(0.15, 6, 5), color: "#c7b27a", position: [-0.2, 0.12, 0.04], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.045, 0.05, 6), color: "#8a6a3a", position: [-0.2, 0.237, 0.04] },
      { geometry: new THREE.SphereGeometry(0.15, 6, 5), color: "#b8a36c", position: [0.06, 0.12, -0.06], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.045, 0.05, 6), color: "#8a6a3a", position: [0.06, 0.237, -0.06] },
      { geometry: new THREE.SphereGeometry(0.15, 6, 5), color: "#c7b27a", position: [0.22, 0.12, 0.1], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.045, 0.05, 6), color: "#8a6a3a", position: [0.22, 0.237, 0.1] },
      { geometry: new THREE.SphereGeometry(0.15, 6, 5), color: "#b8a36c", position: [-0.06, 0.2775, 0], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.045, 0.05, 6), color: "#8a6a3a", position: [-0.06, 0.3945, 0] },
      { geometry: new THREE.SphereGeometry(0.15, 6, 5), color: "#c7b27a", position: [0.12, 0.2775, 0.04], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.045, 0.05, 6), color: "#8a6a3a", position: [0.12, 0.3945, 0.04] },
    ],
  animations: [],
});
